import { compose, mapProps, branch, renderNothing } from 'recompose'
import moment from 'moment-timezone'
import { INV_GUARANTEE_DISPOSITION } from '@signifyd/http'
import isRecommendationOrder from 'core/utils/isRecommendationOrder'
import type { RecommendationDisposition } from 'caseReport/networkCalls/recommendations/types'
import CaseTimeout from './CaseTimeout'

type DeadlineDisplayProps = {
  deadlineHours: number
  deadlineMins: number
  timeUnitMins: string
  timeUnitHours: string
}

type ReviewDeadlineSource = {
  guaranteeDisposition?: INV_GUARANTEE_DISPOSITION | null
  recommendedDecisionDisposition?: RecommendationDisposition | null
  guaranteeReviewDeadline?: string | null
  recommendedReviewDeadline?: string | null
}

type Props = {
  currentCase: ReviewDeadlineSource
}

const getReviewDeadline = ({
  guaranteeDisposition,
  recommendedDecisionDisposition,
  guaranteeReviewDeadline,
  recommendedReviewDeadline,
}: ReviewDeadlineSource): string | null | undefined => {
  if (
    !isRecommendationOrder(guaranteeDisposition, recommendedDecisionDisposition)
  ) {
    return guaranteeReviewDeadline
  }

  return recommendedReviewDeadline
}

export const normalizeDeadline = ({
  currentCase,
}: Props): DeadlineDisplayProps | null => {
  const deadlineDate = moment(getReviewDeadline(currentCase))
  if (!deadlineDate.isValid()) {
    return null
  }
  const now = moment(new Date())
  const diff = Math.ceil(deadlineDate.diff(now, 'minutes', true))
  const invalidDeadline = diff < 0
  if (invalidDeadline) {
    return null
  }
  const deadlineMins = diff % 60
  const deadlineHours = Math.floor((diff - deadlineMins) / 60)

  return {
    deadlineHours,
    deadlineMins,
    timeUnitHours: deadlineHours > 1 ? 'hours' : 'hour',
    timeUnitMins: deadlineMins > 1 ? 'mins' : 'min',
  }
}
const enhance = compose<DeadlineDisplayProps, Props>(
  mapProps(normalizeDeadline),
  branch((props) => !props, renderNothing)
)

export default enhance(CaseTimeout)
